<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.beneficiariesNumber.title"
                        [body]="{
                            value: kpi.beneficiariesNumber,
                            precision: texts.beneficiariesNumber.precision,
                        }"
                        [badge]="{
                            value: kpi.beneficiariesNumberEvolution,
                            suffix: texts.beneficiariesNumber.badge.suffix,
                            precision: texts.beneficiariesNumber.badge.precision,
                            style: 'info',
                        }"
                        [descriptionTitle]="texts.beneficiariesNumber.description.title"
                        [descriptionContent]="texts.beneficiariesNumber.description.content"
                        [isLoading]="!kpi.organizationId"
                        [error]="
                            checkKpiErrors(
                                kpi,
                                'beneficiariesNumber',
                                'beneficiariesNumberEvolution'
                            )
                        "
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.reductionsPowerNumber.title"
                        [body]="{
                            value: kpi.reductionsPowerNumber,
                            precision: texts.reductionsPowerNumber.precision,
                        }"
                        [badge]="{
                            value: kpi.reductionsPowerNumberEvolution,
                            suffix: texts.reductionsPowerNumber.badge.suffix,
                            precision: texts.reductionsPowerNumber.badge.precision,
                            style: 'info',
                        }"
                        [descriptionTitle]="texts.reductionsPowerNumber.description.title"
                        [descriptionContent]="texts.reductionsPowerNumber.description.content"
                        [isLoading]="!kpi.organizationId"
                        [error]="
                            checkKpiErrors(
                                kpi,
                                'reductionsPowerNumber',
                                'reductionsPowerNumberEvolution'
                            )
                        "
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <chart-card
                id="evolNbrBeneficiariesChart"
                [title]="texts.evolNbrBeneficiariesChart.title"
                [error]="benefiChartError"
                [isLoading]="!benefiChartData()[0].organizationId"
                [series]="benefiChartSeries"
                [dataLabels]="benefiDataLabels"
                [stacked]="true"
                [yaxis]="benefiYaxis"
                [xaxisCategories]="benefiXaxisCategories"
                [precision]="texts.evolNbrBeneficiariesChart.precision"
                [customTooltip]="benefiCustomTooltip"
                [xaxisTitle]="texts.evolNbrBeneficiariesChart.xaxisTitle"
                class="h-100">
            </chart-card>

            <chart-card
                id="evolAmountFileAssistedChart"
                [title]="texts.evolAmountFileAssistedChart.title"
                [error]="amountChartError"
                [isLoading]="!amountChartData()[0].organizationId"
                [series]="amountChartSeries"
                [dataLabels]="amountDataLabels"
                [stacked]="true"
                [yaxis]="amountYaxis"
                [xaxisCategories]="amountXaxisCategories"
                [precision]="texts.evolAmountFileAssistedChart.precision"
                [xaxisTitle]="texts.evolAmountFileAssistedChart.xaxisTitle"
                class="h-100">
            </chart-card>

            <chart-card
                id="evolReducPowerChart"
                [title]="texts.evolReducPowerChart.title"
                [error]="reducChartError"
                [isLoading]="!reducChartData()[0].organizationId"
                [series]="reducChartSeries"
                [dataLabels]="reducDataLabels"
                [stacked]="false"
                [yaxis]="reducYaxis"
                [xaxisCategories]="reducXaxisCategories"
                [customTooltip]="reducCustomTooltip"
                [xaxisTitle]="texts.evolReducPowerChart.xaxisTitle"
                class="h-100">
            </chart-card>

            <chart-card
                id="evolCutsSupplierChart"
                [title]="texts.evolCutsSupplierChart.title"
                [error]="cutsChartError"
                [isLoading]="!cutsChartData()[0].organizationId"
                [series]="cutsChartSeries"
                [dataLabels]="cutsDataLabels"
                [stacked]="true"
                [yaxis]="cutsYaxis"
                [xaxisCategories]="cutsXaxisCategories"
                [customTooltip]="cutsCustomTooltip"
                [xaxisTitle]="texts.evolCutsSupplierChart.xaxisTitle"
                class="h-100">
            </chart-card>
        </div>
    </div>
</div>
